// Header navigation: collapse the inline pill nav into a burger menu whenever the
// links no longer fit beside the logo. Width-based fit test (not a fixed
// breakpoint), so it adapts to however many nav items the site has.
(function () {
    var head = document.getElementById('gh-head');
    if (!head) { return; }

    var inner = head.querySelector('.gh-head-inner');
    var brand = head.querySelector('.gh-head-brand');
    var menu = head.querySelector('.gh-head-menu');
    // The links group (nav + Play Now CTA) is what collapses into the dropdown.
    var links = menu && menu.querySelector('.gh-head-links');
    var burger = head.querySelector('.gh-burger');
    if (!inner || !brand || !menu || !links || !burger) { return; }

    // Comfortable gap (px) we want between the logo and the links before collapsing.
    var COMFORT = 56;
    // Width the expanded header needs (logo + links + gap). Cached because it does
    // not change with viewport width — the pill buttons are fixed-size.
    var needed = 0;

    function setOpen(open) {
        document.body.classList.toggle('gh-head-open', open);
        burger.setAttribute('aria-expanded', String(open));
    }

    // Read the natural expanded width. Must be done in the expanded state, so we
    // briefly drop .is-collapsed — but synchronously (no paint between), so it
    // never flickers. Only called on load / font-load, never on every resize.
    function measure() {
        var collapsed = head.classList.contains('is-collapsed');
        if (collapsed) { head.classList.remove('is-collapsed'); }
        needed = brand.offsetWidth + links.scrollWidth + COMFORT;
        if (collapsed) { head.classList.add('is-collapsed'); }
    }

    // Apply the decision using the cached width — a single class toggle, so
    // resizing across the threshold flips it once with no flicker.
    function apply() {
        var collapse = needed > inner.clientWidth;
        head.classList.toggle('is-collapsed', collapse);
        if (!collapse) { setOpen(false); }
    }

    burger.addEventListener('click', function (e) {
        e.stopPropagation();
        setOpen(!document.body.classList.contains('gh-head-open'));
    });

    // Dismiss the open dropdown on Escape or a click outside the header.
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { setOpen(false); }
    });
    document.addEventListener('click', function (e) {
        if (document.body.classList.contains('gh-head-open') && !head.contains(e.target)) {
            setOpen(false);
        }
    });

    var raf;
    window.addEventListener('resize', function () {
        if (raf) { cancelAnimationFrame(raf); }
        raf = requestAnimationFrame(apply); // toggle only — needed is cached
    });

    // (Re)measure when widths can change: initial, after images/layout settle,
    // and after the web fonts load (which changes the links' width).
    function remeasure() { measure(); apply(); }
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(remeasure);
    }
    remeasure();
    // Decision made — reveal the menu (it was hidden to avoid a flash of the
    // un-collapsed nav before this ran).
    head.classList.add('nav-ready');
})();
